<template>
  <div>
    <rotaion
      :height="height"
      :route="this.$route.path"
      arrow="never"
      position="none"
    ></rotaion>
    <div class="center-content">
      <Invite></Invite>
      <!-- <div class="relocation" @click="backTop" v-show="isShow">
      <span
        class="icon iconfont icon-Up-"
        style="
          line-height: 3rem;
          font-size: 1.6rem;
          color: #ffffff;
          cursor: default;
        "
      ></span>
    </div> -->
      <bottom></bottom>
    </div>
  </div>
</template>

<script>
import rotaion from "./components/rotation";
import bottom from "./components/bottom";
import Invite from "../components/Invite/Invite.vue";
export default {
  components: {
    rotaion,
    bottom,
    Invite,
  },
  data() {
    return {
      isShow: false,
      height: window.innerHeight,
    };
  },
  mounted() {
    window.addEventListener("mousewheel", this.getScroll, false);
    if (this.getScrollTop() > 200) {
      this.isShow = true;
    }
  },
  methods: {
    getScroll(event) {
      if (window.scrollY > 200) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    backTop() {
      let that = this;
      let timer = setInterval(function () {
        if (document.documentElement.scrollTop) {
          document.documentElement.scrollTop -= 10;
        } else {
          document.body.scrollTop -= 10;
        }
        if (that.getScrollTop() < 200) {
          that.isShow = false;
        }
        if (that.getScrollTop() == 0) {
          clearInterval(timer);
        }
      }, 3);
    },
    getScrollTop() {
      var scroll_top = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scroll_top = document.documentElement.scrollTop;
      } else if (document.body) {
        scroll_top = document.body.scrollTop;
      }
      return scroll_top;
    },
  },
};
</script>

<style scoped>
.relocation {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: rgb(204, 204, 204);
  text-align: center;
  position: fixed;
  z-index: 99;
  right: 8rem;
  bottom: 3.75rem;
}
.relocation:hover {
  background: rgb(153, 153, 153);
}
.center-content {
  position: absolute;
  top: 70%;
  z-index: 10000000;
  background-color: #ffffff;
  width: 100%;
}
</style>
